import { render, staticRenderFns } from "./CategoriesAdd.vue?vue&type=template&id=00053c0b&scoped=true"
import script from "./CategoriesAdd.vue?vue&type=script&lang=js"
export * from "./CategoriesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00053c0b",
  null
  
)

export default component.exports